import React from "react";

import {
  FIELD_TYPE,
  FORMAT_TIME,
  tabKeys,
  TT_PHIEU_KHO,
  TT_PHIEU_VTYT,
} from "types/enums";

import { DataFormField } from "types/models/input-field-type";

import { ColumnProps } from "../../../../../types/models";
import dayjs from 'dayjs';

const {
  INPUT,
  DATE_DISABLE_NO_DAY,
  DATE,
  COMBO_BOX,
  AUTO_COMPLETE,
  CODE,
  NUMBER,
  DATE_DISABLE,
} = FIELD_TYPE;

const allColumns: ColumnProps[] = [
  {
    title: "STT",
    key: "index",
    show: true,
    dataIndex: "index",
    render(_, __, index) {
      return <>{index + 1}</>;
    },
    disabledCheck: true,
    fixed: "left",
    width: 20,
    align: "center",
    isResizable: true,
  },
  {
    title: "Mã nhân viên",
    key: "maNhanVien",
    show: true,
    dataIndex: "maNhanVien",
    fixed: "left",
    align: "left",
    isResizable: true,
  },
  {
    title: "Họ tên",
    key: "tenNhanVien",
    show: true,
    dataIndex: "tenNhanVien",
    fixed:"left",
    align: "left",
    isResizable: true,
  },
  {
    title: "Số quyết định",
    key: "soQuyetDinh",
    show: true,
    dataIndex: "soQuyetDinh",

    align: "left",
    isResizable: true,
  },
  {
    title: "Ngày kỷ luật",
    key: "ngayKyLuat",
    show: true,
    dataIndex: "ngayKyLuat",
    render: (v, r, idx) => v !== null ? dayjs(v).format("DD/MM/YYYY") : null ,
    align: "center",
    isResizable: true,
  },
  {
    title: "Hình thức xử lý",
    key: "hinhThucXuLy",
    show: true,
    dataIndex: "hinhThucXuLy",
    width:160,
    align: "center",
    isResizable: true,
  },
  {
    title: "Cá nhân liên quan",
    key: "caNhanLienQuan",
    show: true,
    dataIndex: "caNhanLienQuan",
    width:260,
    align: "left",
    isResizable: true,
  },
  {
    title: "Thời gian thử thách",
    key: "thoiGianThuThach",
    show: true,
    dataIndex: "thoiGianThuThach",
    width:260,
    align: "center",
    render: (v, r, idx) => v !== null ? dayjs(v).format("DD/MM/YYYY") : null ,
    isResizable: true,
  },
  {
    title: "Theo dõi",
    key: "theoDoi",
    show: true,
    dataIndex: "theoDoi",
    width:260,
    align: "left",
    isResizable: true,
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    show: true,
    align: "center",
    fixed: "right",
    width: 160,
    key: "action",
  },
];
const itemsInputField: DataFormField[] = [
  {
    type: COMBO_BOX,
    name: "maNhanVien",
    label: "Nhân viên",
  },
  {
    type: DATE_DISABLE_NO_DAY,
    name: "tuNgay",
    label: "Từ ngày",
    disableDate: false,
    optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
  },
  {
    type: DATE_DISABLE_NO_DAY,
    name: "denNgay",
    label: "Đến ngày",
    disableDate: false,
    optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
  },
  {
    type: INPUT,
    name: "soQuyetDinh",
    label: "Số QĐ",
  },
];

export { allColumns, itemsInputField };
